import React from "react";
import ResourcePage from "../components/ResourcePage";

export function Transactions() {
  return (
    <ResourcePage
      title="Income & Expenses"
      subtitle="Record money in and out. Customers (income) and vendors (expense) are pulled from their tables."
      endpoint="transactions"
      testid="txn"
      columns={[
        { key: "date", label: "Date", type: "date" },
        { key: "type", label: "Type", type: "badge" },
        { key: "category", label: "Category" },
        { key: "party_name", label: "Vendor / Customer" },
        { key: "description", label: "Description" },
        { key: "amount", label: "Amount", type: "money", bold: true },
      ]}
      fields={[
        { key: "type", label: "Type", type: "select", options: [
          { value: "income", label: "Income" }, { value: "expense", label: "Expense" }] },
        { key: "party_name", label: "Vendor / Customer", type: "relation",
          endpointByField: { field: "type", map: { income: "customers", expense: "vendors" } },
          optionLabel: "name", idField: "party_id", allowCustom: true, full: true,
          placeholder: "Select a customer or vendor" },
        { key: "category", label: "Category", type: "text" },
        { key: "amount", label: "Amount", type: "number" },
        { key: "date", label: "Date", type: "date" },
        { key: "description", label: "Description", type: "textarea", full: true },
      ]}
    />
  );
}

export function Livestock() {
  return (
    <ResourcePage
      title="Livestock"
      subtitle="Track your herds, flocks and animal health."
      endpoint="livestock"
      testid="ls"
      columns={[
        { key: "tag", label: "Tag / ID", bold: true },
        { key: "species", label: "Species" },
        { key: "breed", label: "Breed" },
        { key: "count", label: "Head", type: "number" },
        { key: "status", label: "Status", type: "badge" },
        { key: "weight", label: "Weight (kg)", type: "number" },
      ]}
      fields={[
        { key: "tag", label: "Tag / ID", type: "text" },
        { key: "species", label: "Species", type: "select", options: [
          { value: "Pigs", label: "Pigs" }, { value: "Snails", label: "Snails" },
          { value: "Fish", label: "Fish" }, { value: "Goats", label: "Goats" },
          { value: "Poultry", label: "Poultry" }] },
        { key: "breed", label: "Breed", type: "text" },
        { key: "count", label: "Head count", type: "number", default: 1 },
        { key: "status", label: "Status", type: "select", options: [
          { value: "healthy", label: "Healthy" }, { value: "sick", label: "Sick" },
          { value: "pregnant", label: "Pregnant" }, { value: "sold", label: "Sold" },
          { value: "deceased", label: "Deceased" }] },
        { key: "weight", label: "Weight (kg)", type: "number" },
        { key: "acquired_date", label: "Acquired date", type: "date" },
        { key: "notes", label: "Notes", type: "textarea", full: true },
      ]}
    />
  );
}

export function Crops() {
  return (
    <ResourcePage
      title="Crops"
      subtitle="Plan plantings and monitor field progress."
      endpoint="crops"
      testid="crop"
      columns={[
        { key: "name", label: "Crop", bold: true },
        { key: "field_name", label: "Field" },
        { key: "area_acres", label: "Acres", type: "number" },
        { key: "status", label: "Status", type: "badge" },
        { key: "planting_date", label: "Planted", type: "date" },
        { key: "harvest_date", label: "Harvest", type: "date" },
      ]}
      fields={[
        { key: "name", label: "Crop name", type: "text" },
        { key: "field_name", label: "Field", type: "text" },
        { key: "area_acres", label: "Area (acres)", type: "number" },
        { key: "status", label: "Status", type: "select", options: [
          { value: "planned", label: "Planned" }, { value: "planted", label: "Planted" },
          { value: "growing", label: "Growing" }, { value: "harvested", label: "Harvested" }] },
        { key: "planting_date", label: "Planting date", type: "date" },
        { key: "harvest_date", label: "Harvest date", type: "date" },
        { key: "expected_yield", label: "Expected yield", type: "text", full: true },
      ]}
    />
  );
}

export function Inventory() {
  return (
    <ResourcePage
      title="Inventory"
      subtitle="Feed, seed, fuel, equipment and supplies."
      endpoint="inventory"
      testid="itm"
      columns={[
        { key: "name", label: "Item", bold: true },
        { key: "category", label: "Category" },
        { key: "quantity", label: "Qty", type: "number" },
        { key: "unit", label: "Unit" },
        { key: "unit_cost", label: "Unit cost", type: "money" },
        { key: "reorder_level", label: "Reorder at", type: "number" },
      ]}
      fields={[
        { key: "name", label: "Item name", type: "text" },
        { key: "category", label: "Category", type: "text" },
        { key: "quantity", label: "Quantity", type: "number" },
        { key: "unit", label: "Unit (kg, L, bags…)", type: "text", default: "units" },
        { key: "unit_cost", label: "Unit cost", type: "number" },
        { key: "reorder_level", label: "Reorder level", type: "number" },
      ]}
    />
  );
}

// Employees moved to dedicated page: pages/Employees.jsx (linked to staff accounts)

export function Customers() {
  return (
    <ResourcePage
      title="Customers"
      subtitle="Your customer directory — used to auto-fill invoices, sales, receipts and online orders."
      endpoint="customers"
      testid="cust"
      columns={[
        { key: "name", label: "Name", bold: true },
        { key: "phone", label: "Phone" },
        { key: "email", label: "Email" },
        { key: "address", label: "Address" },
      ]}
      fields={[
        { key: "name", label: "Customer name", type: "text" },
        { key: "phone", label: "Phone", type: "text" },
        { key: "email", label: "Email", type: "text" },
        { key: "address", label: "Address", type: "textarea", full: true },
        { key: "notes", label: "Notes", type: "textarea", full: true },
      ]}
    />
  );
}


